// // src/pages/LoginPage.js
// import React from 'react';
// import { Container, Form, Button, Card, Row, Col } from 'react-bootstrap';
// import { FaSignInAlt } from 'react-icons/fa';
// import { Link } from 'react-router-dom';

// const LoginPage = () => {
//   return (
//     <Container className="py-5">
//       <Row className="justify-content-center">
//         <Col md={6}>
//           <Card>
//             <Card.Body>
//               <h2 className="text-center mb-4">
//                 <FaSignInAlt className="me-2" />
//                 Login
//               </h2>
//               <Form>
//                 <Form.Group className="mb-3" controlId="email">
//                   <Form.Label>Email address</Form.Label>
//                   <Form.Control type="email" placeholder="Enter email" />
//                 </Form.Group>

//                 <Form.Group className="mb-3" controlId="password">
//                   <Form.Label>Password</Form.Label>
//                   <Form.Control type="password" placeholder="Password" />
//                 </Form.Group>

//                 <Form.Group className="mb-3" controlId="rememberMe">
//                   <Form.Check type="checkbox" label="Remember me" />
//                 </Form.Group>

//                 <div className="d-grid">
//                   <Button variant="primary" type="submit">
//                     Login
//                   </Button>
//                 </div>
//               </Form>

//               <div className="text-center mt-3">
//                 <Link to="/register">Don't have an account? Register</Link>
//               </div>
//               <div className="text-center mt-2">
//                 <Link to="/forgot-password">Forgot password?</Link>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default LoginPage;

import React from 'react';
import { Container, Form, Button, Card, Row, Col } from 'react-bootstrap';
import { FaSignInAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const LoginPage = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <Card>
            <Card.Body>
              <h2 className="text-center mb-4">
                <FaSignInAlt className="me-2" />
                Login
              </h2>
              <Form>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control type="email" placeholder="Enter email" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password" placeholder="Password" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="rememberMe">
                  <Form.Check type="checkbox" label="Remember me" />
                </Form.Group>

                <div className="d-grid">
                  <Button variant="primary" type="submit">
                    Login
                  </Button>
                </div>
              </Form>

              <div className="text-center mt-3">
                <Link to="/register">Don't have an account? Register</Link>
              </div>
              <div className="text-center mt-2">
                <Link to="/forgot-password">Forgot password?</Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
